import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { matrizClickEntity } from '../../../elements/riesgo-credito/entities_riesgos/entities_riesgos';
import { Loggers } from '../../../util/app-util';
import { MessageService } from '../base/message.service';
import { Service } from '../base/service';

@Injectable({
  providedIn: 'root'
})
export class MatrizClickService extends Service<matrizClickEntity>{
  httpClient: HttpClient;
    constructor(
      http: HttpClient,
      messageService: MessageService,
      protected override logger: Loggers,
      cookiesService: CookieService
    ) { 
      super('matrizTR','',http, messageService, logger, cookiesService);
      this.httpClient = http;
    }
    protected getParams(entity: matrizClickEntity):HttpParams{
      let params: HttpParams = new HttpParams();
      if (null == entity){return params;}
      if (null != entity.InstitucionId){params = params.set('InstitucionId', entity.InstitucionId)}
      if (null != entity.Periodo){params = params.set('Periodo', entity.Periodo)}
      if (null != entity.PeriodoAnterior){params = params.set('PeriodoAnterior', entity.PeriodoAnterior)}
      if (null != entity.PAR){params = params.set('PAR', entity.PAR)}
      if (null != entity.BnPAR_Inclusive){params = params.set('BnPAR_Inclusive', entity.BnPAR_Inclusive)}
      if (null != entity.CategoriaCreditoId_Actual){params = params.set('CategoriaCreditoId_Actual', entity.CategoriaCreditoId_Actual)}
      if (null != entity.CategoriaCreditoId_Anterior){params = params.set('CategoriaCreditoId_Anterior', entity.CategoriaCreditoId_Anterior)}

    return params;
    }
}
